import {
  Box,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import { Stack } from "@mui/system";
import React from "react";
import { StyledLabel } from "../../../common/components/InputLabel";

const MidlineCorrectionInput = ({ error, register }) => {
  const messages = error
    ? Object.keys(error).map((key) => {
        const err = error[key];
        if (err) {
          return err.message;
        } else {
          return undefined;
        }
      })
    : [];

  return (
    <React.Fragment>
      <Grid item xs={3} sx={{ marginTop: 1 }}>
        <Box>
          <StyledLabel
            error={!messages.every((err) => err === undefined)}
            id="midline-correction-label"
          >
            Midline Correction
          </StyledLabel>
          <Typography sx={{ fontSize: "0.875rem" }}>
            (recommended limit ≤ 2mm)
          </Typography>
        </Box>
        {messages.map((message) => (
          <FormHelperText error={true}>{message}</FormHelperText>
        ))}
      </Grid>
      <Grid item xs={9}>
        <Stack direction="row" spacing={6}>
          <FormControl>
            <Box id="upper-spacing-label" sx={{ fontWeight: 600 }}>
              Upper
            </Box>
            <RadioGroup name="midline.upper">
              <FormControlLabel
                value="Maintain"
                control={<Radio {...register("upperMidline")} />}
                label="Maintain"
              />
              <FormControlLabel
                value="Move"
                control={<Radio {...register("upperMidline")} />}
                label="Move"
              />

              <Box sx={{ width: "252px", height: "1px" }} />
            </RadioGroup>
          </FormControl>

          <FormControl>
            <Box id="lower-spacing-label" sx={{ fontWeight: 600 }}>
              Lower
            </Box>
            <RadioGroup name="midline.lower">
              <FormControlLabel
                value="Maintain"
                control={<Radio {...register("lowerMidline")} />}
                label="Maintain"
              />
              <FormControlLabel
                value="Move"
                control={<Radio {...register("lowerMidline")} />}
                label="Move"
              />
            </RadioGroup>
          </FormControl>
        </Stack>
      </Grid>
    </React.Fragment>
  );
};

export default MidlineCorrectionInput;
